import { defineStore } from 'pinia'
import Tracker from '@nio-fe/nio-tracker-web'
import { ConfigItem } from '../contract/map'
import { IPoint } from '@/contract/map.base'
import { getConfigs } from '@/biz/apis/config.api'
import { useComponentStore } from '../nsh5/localStores/component'

let retryNumDictionary = 0

interface AppState {
  /**
   * 地图中心点
   */
  center: IPoint
  /**
   * 地图缩放等级
   */
  zoomLevel: number
  /**
   * 地图最小缩放等级
   */
  minZoomLevel: number
  /**
   * 地图最大缩放等级
   */
  maxZoomLevel: number
  /**
   * 字典数据, 用于读取那些cdn url
   */
  dictionaries: ConfigItem[]
  /**
   * 中国边界配置，用于防止拖出
   */
  chinaBoundSW: IPoint
  chinaBoundNE: IPoint
  /**
   * 埋点公参
   */
  trackParamsCommon: object
  /**
   * 埋点用，页面起始时间
   */
  pageStartTime: number
  /**
   * 埋点用，定位成功与否
   */
  locationSuccess: boolean
  // /**
  //  * 搜索选择暂存
  //  */
  // tempSearchPoiResource: string
}

export const useAppStore = defineStore('app', {
  state: (): AppState => ({
    // 地图初始化默认配置
    center: { lng: 104.32311750545072, lat: 37.98802757150653 },
    zoomLevel: 5,
    minZoomLevel: 1,
    maxZoomLevel: 17,
    // 全局数据
    dictionaries: [],
    chinaBoundSW: { lng: 73.175651, lat: 15.564126 }, // chinaBoundSW: { lng: 73.175651, lat: 2.564126 },
    chinaBoundNE: { lng: 135.470584, lat: 53.965794 },
    trackParamsCommon: {
      platid: '',
      adsourceid: '',
      userToken: '',
    },
    pageStartTime: 0,
    locationSuccess: true, //定位成功设置为true，定位失败设置为false
    // tempSearchPoiResource: '',
  }),
  actions: {
    /**
     * 获取系统配置参数 ++++++
     * @param {string} [codes] 参数code；多个以,隔开，不传返回全部
     */
    async getConfigs(codes?: string) {
      // filter功能关闭的时候走兜底配置
      const filterShow = () => {
        return (
          (config?.filter?.show
            ? config?.filter?.properties?.items
            : config?.filter?.properties?.default_items) || ''
        )
      }
      const config = window.NSComponentsConfig
      const suffix = (process.config as any).dict_suffix
      const codeArr = [
        'h5_recommend_route_high_speed_config', // 区分高速的标签
        config?.route_render?.show ? 'h5_charging_trip_route_link' + suffix : '', // 加电旅程路线和加电旅程详情
        // -------------兼容recharge处理----0523后可删除filterShow().includes('recharge')-------
        filterShow().includes('recharge') || filterShow().includes('recharge|ps')
          ? 'h5_charge_map_power_swap_resource_cdn_link' + suffix
          : '', // 国内NIO换电站资源点cdn地址
        filterShow().includes('recharge') || filterShow().includes('recharge|cs')
          ? 'h5_charge_map_charge_station_resource_cdn_link' + suffix
          : '', // 国内NIO充电站资源点cdn地址
        (filterShow().includes('recharge') || filterShow().includes('recharge|cs')) &&
        config?.third_resource?.show
          ? 'h5_charge_map_third_resource_cdn_link' + suffix
          : '', // 国内三方资源点cdn地址
        // ------------------------
        filterShow().includes('test_drive')
          ? 'h5_charge_map_test_drive_resource_cdn_link' + suffix
          : '', // 试驾点全国资源
        filterShow().includes('nio_store')
          ? 'h5_charge_map_nio_store_resource_cdn_link' + suffix
          : '', // 蔚来门店全国资源
        filterShow().includes('service_center')
          ? 'h5_charge_map_service_center_resource_cdn_link' + suffix
          : '', // 服务中心
        config?.route_plan?.show ? 'h5_charge_map_route_plan_strategy_config' + suffix : '', // 路径规划筛选接口
        config?.wishpower?.show ? 'h5_wish_stations_address_cdn_link' + suffix : '', // 心愿站全国换电站资源
      ]
      const res = await getConfigs(codes || codeArr.filter((a) => a).join(','))
      if (res.isValid()) {
        const componentStore = useComponentStore()
        componentStore.$patch({
          dictionaries: res.data as ConfigItem[],
        })
        this.dictionaries = res.data as ConfigItem[]
        return Promise.resolve('success')
      } else {
        // 重试
        if (retryNumDictionary < 3) {
          // 重试，1-5秒内随机时间重试
          const randomTime = Math.round(Math.random() * 5 * 1000)
          setTimeout(() => {
            // 重试执行 getComponentsConfig方法
            retryNumDictionary++
            this.getConfigs(codes)
          }, randomTime)
        }
        return Promise.resolve('error')
      }
    },
  },
})
